module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page"
  }, [_c('div', {
    staticClass: "page-content"
  }, [_c('page-nav-bar', {
    attrs: {
      "currentServiceName": "MoneyRoad",
      "subNavTitle": "Settings",
      "menuAccess": true
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "layoutTop"
  }), _vm._v(" "), _c('div', {
    staticClass: "container-fluid"
  }, [_c('div', {
    staticClass: "settingBetweenList"
  }), _vm._v(" "), _c('div', {
    staticClass: "list-block"
  }, [_c('ul', [(_vm.serviceName === 'Payments' || _vm.serviceName === '') ? _c('li', [_c('a', {
    staticClass: "item-link item-content",
    attrs: {
      "href": "/settings/application/"
    }
  }, [_c('div', {
    staticClass: "item-inner"
  }, [_c('div', {
    staticClass: "item-title"
  }, [_vm._v(_vm._s(_vm.$t('settings.applctn_sttngs')))])])])]) : (_vm.serviceName === 'Direct Debit') ? _c('li', [_c('a', {
    staticClass: "item-link item-content",
    attrs: {
      "href": "/settings/directDebit/"
    }
  }, [_c('div', {
    staticClass: "item-inner"
  }, [_c('div', {
    staticClass: "item-title"
  }, [_vm._v(_vm._s(_vm.$t('settings.applctn_sttngs')))])])])]) : (_vm.serviceName === 'Direct Payments') ? _c('li', [_c('a', {
    staticClass: "item-link item-content",
    attrs: {
      "href": "/settings/directPayments/"
    }
  }, [_c('div', {
    staticClass: "item-inner"
  }, [_c('div', {
    staticClass: "item-title"
  }, [_vm._v(_vm._s(_vm.$t('settings.applctn_sttngs')))])])])]) : _vm._e(), _vm._v(" "), _vm._m(0)])]), _vm._v(" "), _c('div', {
    staticClass: "toolbarPageBottomBlank"
  })])], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('a', {
    staticClass: "item-link item-content",
    attrs: {
      "href": "/settings/remind/"
    }
  }, [_c('div', {
    staticClass: "item-inner"
  }, [_c('div', {
    staticClass: "item-title"
  }, [_vm._v("Remind Settings")])])])])
}]}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-62e3acf4", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-62e3acf4","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/settings/CMSettingPage.vue
// module id = 2436
// module chunks = 2